module.exports = __webpack_public_path__ + "img/E1 UP2.14e91cbc.png";